import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import classNames from 'classnames';

import './ProductsFormBrandInput.css';

function renderBrands(brands) {
  return brands.map(brand => (
    <option key={`ProductsTable__brand-input_option_${brand}`} value={brand}>
      {brand}
    </option>
  ));
}

export default function BrandInput({ name, errored, brands }) {
  const className = classNames('ProductsTable__brand-input', {
    'ProductsTable__brand-input--errored': errored,
  });
  return (
    <div className={className}>
      <Field component="select" name={name}>
        {renderBrands(brands)}
      </Field>
    </div>
  );
}

BrandInput.propTypes = {
  name: PropTypes.string.isRequired,
  errored: PropTypes.bool.isRequired,
  brands: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ../ui-components/components/DealerProducts/Inputs/ProductsFormBrandInput.jsx